<div class="flex h-full flex-col justify-between">
  <form class="gap-lg flex flex-col" [formGroup]="form">
    <div hlmField>
      <label hlmFieldLabel for="select-instituts-metier">Institut Métier</label>
      <brn-select class="inline-block" id="select-instituts-metier" formControlName="institut">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>
        <hlm-select-content>
          @for (item of equipesResponsables | trierPar: 'nom'; track $index) {
            <hlm-option [value]="item.href">
              {{ item.type === 'Métier' ? item.href + ' - ' : '' }}{{ item.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </brn-select>
    </div>

    @if (estMetier()) {
      <div hlmField>
        <label hlmFieldLabel for="select-metier">Métier</label>
        @if (referentielsFiltres().length > 0) {
          <brn-select class="inline-block" id="select-metier" formControlName="metier">
            <hlm-select-trigger>
              <hlm-select-value />
            </hlm-select-trigger>
            <hlm-select-content>
              @for (item of referentielsFiltres() | trierPar: 'nom'; track $index) {
                <hlm-option [value]="item.id">{{ item.nom }}</hlm-option>
              }
            </hlm-select-content>
          </brn-select>
        } @else {
          <app-alerte
            message="Pour pouvoir sélectionner un référentiel, il faut que les administrateurs créent un ou plusieurs référentiels pour cet institut."
          />
        }
      </div>
    }

    <div hlmField>
      <label hlmFieldLabel for="select-publics-cibles">Publics cibles</label>
      <brn-select class="inline-block" id="select-publics-cibles" formControlName="publicsCibles" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>
        <hlm-select-content>
          @for (item of publicsCibles(); track $index) {
            <hlm-option [value]="item">{{ item }}</hlm-option>
          }
        </hlm-select-content>
      </brn-select>
    </div>
    <div class="ml-xs mt-sm">
      <button
        class="text-components-content-neutral-secondary component-small-medium pl-0 underline"
        hlmBtn
        variant="link"
        type="reset"
      >
        Réinitialiser les filtres
      </button>
    </div>
  </form>
</div>
